import React, { lazy } from 'react';
import { Target, Zap, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteesSection() {
  return <section className="py-24 bg-[#050505] relative overflow-hidden border-y border-gray-900" data-id="element-2501" data-mp="3oe0uvlsvttjt">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(20,20,20,0.5)_1px,transparent_1px),linear-gradient(90deg,rgba(20,20,20,0.5)_1px,transparent_1px)] bg-[size:40px_40px] opacity-50 pointer-events-none" data-id="element-2502" data-mp="3ei7ko92myc57" />

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-2503" data-mp="34rw51p9laeih">
        <div className="text-center mb-20" data-id="element-2504" data-mp="34qbahzn9yvkm">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 uppercase tracking-tight" data-id="element-2505" data-mp="30rm26lh3g47u">
            Our <span className="text-[#FFD700]" data-id="element-2506" data-mp="2vsiyp5gri61z">Guarantees</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto font-mono" data-id="element-2507" data-mp="2qswh6jtwi3nd">
            Protocol verified. Standards enforced. Peace of mind secured.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-2508" data-mp="1fm18bpe115zx">
          {/* Feature Image with Forensic Frame */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-2 md:order-1 relative group" data-id="element-2509" data-mp="1kd9hckbg2pck">
            {/* Image Container */}
            <div className="relative p-2 border border-[#FF0000]/30 bg-[#0a0a0a]" data-id="element-2510" data-mp="23b3muodd6iq7">
              {/* Corner Markers */}
              <div className="absolute -top-1 -left-1 w-6 h-6 border-t-2 border-l-2 border-[#FF0000]" data-id="element-2511" data-mp="1ogfijdjp9qc6" />
              <div className="absolute -top-1 -right-1 w-6 h-6 border-t-2 border-r-2 border-[#FF0000]" data-id="element-2512" data-mp="1tf8yrdqdfvg1" />
              <div className="absolute -bottom-1 -left-1 w-6 h-6 border-b-2 border-l-2 border-[#FF0000]" data-id="element-2513" data-mp="d1irjy3ygr26" />
              <div className="absolute -bottom-1 -right-1 w-6 h-6 border-b-2 border-r-2 border-[#FF0000]" data-id="element-2514" data-mp="2kky12ms50i6m" />

              <div className="relative overflow-hidden aspect-square flex items-center justify-center bg-[#050505]" data-id="element-2515" data-mp="2fm3b90vr5td0">
                {/* Inline SVG Illustration */}
                <svg viewBox="0 0 200 200" className="w-full h-full p-8 opacity-80 group-hover:opacity-100 transition-opacity duration-700" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-2516" data-mp="2at1sghsfd9o5">
                  {/* Grid Background */}
                  <pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse" data-id="element-2517" data-mp="1rw8yskfci6ta">
                    <path d="M 20 0 L 0 0 0 20" fill="none" stroke="#1F2937" strokeWidth="1" data-id="element-2518" data-mp="1mziko2n3plai" />
                  </pattern>
                  <rect width="200" height="200" fill="url(#grid)" data-id="element-2519" data-mp="3ov9aoklxxlv8" />

                  {/* Shield Base */}
                  <path d="M100 20 L160 40 V90 C160 140 100 180 100 180 C100 180 40 140 40 90 V40 L100 20 Z" fill="#0A0A0A" stroke="#374151" strokeWidth="2" data-id="element-2520" data-mp="3tt0zh5ragrv7" />

                  {/* Inner Shield */}
                  <path d="M100 35 L145 50 V90 C145 130 100 160 100 160 C100 160 55 130 55 90 V50 L100 35 Z" fill="none" stroke="#FF0000" strokeWidth="2" strokeDasharray="4 4" className="animate-[spin_20s_linear_infinite]" style={{
                  transformOrigin: 'center'
                }} data-id="element-2521" data-mp="35wn8f2eotopq" />

                  {/* Lock Core */}
                  <rect x="85" y="90" width="30" height="25" rx="2" fill="#FFD700" stroke="#FFD700" strokeWidth="2" data-id="element-2522" data-mp="10240dekwm5rf" />
                  <path d="M85 90 V80 C85 70 115 70 115 80 V90" fill="none" stroke="#FFD700" strokeWidth="3" strokeLinecap="round" data-id="element-2523" data-mp="17modx8qrpe84" />
                  <circle cx="100" cy="102.5" r="3" fill="#0A0A0A" data-id="element-2524" data-mp="1gl008yklppur" />
                  <path d="M100 105.5 V110" stroke="#0A0A0A" strokeWidth="2" strokeLinecap="round" data-id="element-2525" data-mp="1ckpyjy3udllp" />

                  {/* Crosshairs */}
                  <path d="M100 0 V20 M100 180 V200 M0 100 H20 M180 100 H200" stroke="#FF0000" strokeWidth="1" opacity="0.5" data-id="element-2526" data-mp="1lg5mjyhx16jd" />
                  <circle cx="100" cy="100" r="80" stroke="#FF0000" strokeWidth="1" opacity="0.2" strokeDasharray="2 6" data-id="element-2527" data-mp="2ey27ipnnqwgr" />
                </svg>

                {/* Scan Line Overlay */}
                <div className="absolute top-0 left-0 w-full h-[2px] bg-[#FF0000] shadow-[0_0_15px_#FF0000] animate-[scan_4s_ease-in-out_infinite] opacity-50" data-id="element-2528" data-mp="29x4mm5b9jobk" />

                {/* HUD Overlay Elements */}
                <div className="absolute top-4 left-4 flex gap-2" data-id="element-2529" data-mp="201t7vmzuuh3t">
                  <span className="bg-black/70 border border-[#FF0000]/50 text-[#FF0000] text-[10px] font-mono px-2 py-1" data-id="element-2530" data-mp="1ma6afju6f2jg">
                    SEC ●
                  </span>
                  <span className="bg-black/70 border border-gray-700 text-gray-300 text-[10px] font-mono px-2 py-1" data-id="element-2531" data-mp="1cb7coway8rb8">
                    AES-256
                  </span>
                </div>
              </div>
            </div>

            {/* Decorative Background Blob */}
            <div className="absolute -inset-4 bg-[#FF0000]/5 blur-2xl -z-10 rounded-full opacity-50" data-id="element-2532" data-mp="y78d3ahdx566" />
          </motion.div>

          {/* Guarantees List */}
          <div className="space-y-6 order-1 md:order-2" data-id="element-2533" data-mp="ogdow0kkvvi3">
            {/* Precision Technology */}
            <GuaranteeCard icon={<Target size={24} data-id="element-2535" data-mp="jeengw8ef8ns" />} title="Forensic Precision" description="Our algorithms are calibrated to detect subtext, slang, and context that general AI misses. We don't just read words; we read intent." delay={0.2} data-id="element-2534" data-mp="jhu0ltiii7mk" />

            {/* Lightning Speed */}
            <GuaranteeCard icon={<Zap size={24} data-id="element-2537" data-mp="127sbsihlwguf" />} title="Real-Time Processing" description="From upload to verdict in seconds. Anxiety doesn't wait, and neither should you. Get immediate clarity when you need it most." delay={0.4} data-id="element-2536" data-mp="1270pjy9wfvgt" />

            {/* Accuracy */}
            <GuaranteeCard icon={<CheckCircle2 size={24} data-id="element-2539" data-mp="22h0dcfzlsssd" />} title="99.9% Uptime Reliability" description="Always available for crisis moments. Our systems are redundant and monitored 24/7 to ensure we're there when you spiral." delay={0.6} data-id="element-2538" data-mp="22fyq7d5bcfua" />
          </div>
        </div>
      </div>
    </section>;
}
const GuaranteeCard = ({
  icon,
  title,
  description,
  delay
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
  delay: number;
}) => {
  return <motion.div initial={{
    opacity: 0,
    x: 50
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-[#0a0a0a] p-6 border-l-2 border-gray-800 hover:border-[#FF0000] transition-colors group relative" data-id="element-2540" data-mp="2q2yhfzuvudjj">
      <div className="flex items-start gap-5" data-id="element-2541" data-mp="15ppq3qogz23w">
        <div className="flex-shrink-0 w-12 h-12 bg-[#FF0000]/5 border border-[#FF0000]/20 flex items-center justify-center text-[#FF0000] group-hover:bg-[#FF0000] group-hover:text-white transition-all duration-300" data-id="element-2542" data-mp="37mgo7a94a3pk">
          {icon}
        </div>
        <div className="flex-1 min-w-0" data-id="element-2543" data-mp="3haymnktxbyq1">
          <h3 className="font-bold text-xl text-white mb-2 group-hover:text-[#FF0000] transition-colors uppercase tracking-wide" data-id="element-2544" data-mp="3he4akwqtguk6">
            {title}
          </h3>
          <p className="text-gray-400 text-sm leading-relaxed font-mono" data-id="element-2545" data-mp="2oo4f1oi7gttz">
            {description}
          </p>
        </div>
      </div>

      {/* Active Indicator */}
      <div className="absolute top-4 right-4 w-1.5 h-1.5 bg-[#FF0000] rounded-full opacity-0 group-hover:opacity-100 animate-pulse transition-opacity" data-id="element-2546" data-mp="2ym22i9s8qmlj" />
    </motion.div>;
};